import React from 'react'
import { Stack, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

const SearchEmptySelection = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={2}
      sx={{
        height: '100%',
        minHeight: 250,
        padding: 2,
        py: 4
      }}
    >
      <Typography sx={{ color: theme.palette.text.body.secondary }}>
        {t('master_filter.no_sites_selected')}
      </Typography>
      <i 
        className="fa-light fa-location-dot" 
        style={{ 
          fontSize: '80px', 
          color: theme.palette.surface.tertiary 
        }} 
      />
    </Stack>
  )
}

export default SearchEmptySelection
